<!-- Componente de Información de Auditoría -->
<div *ngIf="hasAuditData()" class="audit-info" [ngClass]="'audit-' + size + ' audit-' + layout">
  
  <!-- Vista Compacta (por defecto) -->
  <div *ngIf="layout === 'compact'" class="audit-compact">
    <button 
      (click)="toggleExpanded()" 
      class="audit-toggle-btn flex items-center gap-2 text-xs text-gray-500 hover:text-gray-700 transition-colors"
      [attr.aria-expanded]="isExpanded"
      aria-label="Mostrar información de auditoría">
      
      <svg class="w-4 h-4 transform transition-transform" 
           [class.rotate-180]="isExpanded" 
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
      
      <span class="font-medium">Auditoría</span>
      
      <!-- Información básica siempre visible -->
      <span *ngIf="auditData.createdAt && !isExpanded" class="text-gray-400">
        • Creado {{ formatDate(auditData.createdAt) }}
      </span>
    </button>

    <!-- Información expandida -->
    <div *ngIf="isExpanded" class="audit-details mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
        
        <!-- Información de Creación -->
        <div *ngIf="auditData.createdBy || auditData.createdAt" class="audit-creation">
          <div class="flex items-center gap-2 mb-2">
            <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg>
            <span class="font-medium text-green-700">Creación</span>
          </div>
          <div class="pl-6 space-y-1">
            <div *ngIf="auditData.createdBy" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <span class="text-gray-600">{{ auditData.createdBy }}</span>
            </div>
            <div *ngIf="auditData.createdAt" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <span class="text-gray-600" [title]="formatDate(auditData.createdAt)">
                {{ formatDate(auditData.createdAt) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Información de Actualización -->
        <div *ngIf="auditData.updatedBy || auditData.updatedAt" class="audit-update">
          <div class="flex items-center gap-2 mb-2">
            <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
            </svg>
            <span class="font-medium text-blue-700">Última Modificación</span>
          </div>
          <div class="pl-6 space-y-1">
            <div *ngIf="auditData.updatedBy" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <span class="text-gray-600">{{ auditData.updatedBy }}</span>
            </div>
            <div *ngIf="auditData.updatedAt" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <span class="text-gray-600" [title]="formatDate(auditData.updatedAt)">
                {{ formatDate(auditData.updatedAt) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Información de Eliminación (si aplica) -->
        <div *ngIf="auditData.isDeleted && (auditData.deletedBy || auditData.deletedAt)" 
             class="audit-deletion md:col-span-2">
          <div class="flex items-center gap-2 mb-2">
            <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
            <span class="font-medium text-red-700">Eliminación</span>
          </div>
          <div class="pl-6 space-y-1">
            <div *ngIf="auditData.deletedBy" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <span class="text-gray-600">Usuario ID: {{ auditData.deletedBy }}</span>
            </div>
            <div *ngIf="auditData.deletedAt" class="flex items-center gap-2">
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <span class="text-gray-600" [title]="formatDate(auditData.deletedAt)">
                {{ formatDate(auditData.deletedAt) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Vista Horizontal (compacta en columna) -->
  <div *ngIf="layout === 'horizontal'" class="audit-horizontal text-xs text-gray-500 space-y-1 min-w-0">
    <div *ngIf="auditData.createdBy || auditData.createdAt" class="flex items-center gap-1 whitespace-nowrap">
      <span class="text-green-600 font-medium">+</span>
      <span class="truncate max-w-[120px]" [title]="auditData.createdBy || 'Sistema'">{{ auditData.createdBy || 'Sistema' }}</span>
      <span *ngIf="auditData.createdAt" class="text-gray-400">{{ formatDate(auditData.createdAt) }}</span>
    </div>
    <div *ngIf="auditData.updatedBy || auditData.updatedAt" class="flex items-center gap-1 whitespace-nowrap">
      <span class="text-blue-600 font-medium">&#x270E;</span>
      <span class="truncate max-w-[120px]" [title]="auditData.updatedBy || 'Sistema'">{{ auditData.updatedBy || 'Sistema' }}</span>
      <span *ngIf="auditData.updatedAt" class="text-gray-400">{{ formatDate(auditData.updatedAt) }}</span>
    </div>
  </div>

  <!-- Vista Vertical -->
  <div *ngIf="layout === 'vertical'" class="audit-vertical space-y-2 text-xs">
    <div *ngIf="auditData.createdBy || auditData.createdAt" class="flex justify-between">
      <span class="text-gray-500">Creado:</span>
      <span class="text-gray-700">
        {{ auditData.createdBy || 'Sistema' }}
        <span *ngIf="auditData.createdAt" class="text-gray-500">
          • {{ formatDate(auditData.createdAt) }}
        </span>
      </span>
    </div>
    
    <div *ngIf="auditData.updatedBy || auditData.updatedAt" class="flex justify-between">
      <span class="text-gray-500">Modificado:</span>
      <span class="text-gray-700">
        {{ auditData.updatedBy || 'Sistema' }}
        <span *ngIf="auditData.updatedAt" class="text-gray-500">
          • {{ formatDate(auditData.updatedAt) }}
        </span>
      </span>
    </div>
  </div>
</div>
